import React, { useEffect, useRef, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { eventuallyInsertKlarnaScript } from "../utility/klarna";
import classNames from "classnames";

const KlarnaPlacement = ({ clientId, sellingPrice, enviroment }) => {
  const containerRef = useRef();
  const [klarnaLoaded, setKlarnaLoaded] = useState();

  const {
    site: { siteMetadata },
  } = useStaticQuery(
    graphql`
      {
        site {
          siteMetadata {
            priceLanguage
          }
        }
      }
    `
  );

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      const klarnaPlacement = document.createElement("klarna-placement");
      klarnaPlacement.setAttribute("data-key", "credit-promotion-badge");
      klarnaPlacement.setAttribute("data-locale", siteMetadata.priceLanguage);
      klarnaPlacement.setAttribute("data-purchase-amount", sellingPrice);
      eventuallyInsertKlarnaScript(clientId, enviroment);

      const activationKlarnaScript = new MutationObserver(function () {
        if (klarnaPlacement.childNodes.length > 0) {
          const klarnaObeservers = [];
          if (klarnaPlacement.shadowRoot.querySelector("div")) {
            const shadowRootKlarnaDivObserver = new MutationObserver(function () {
              setKlarnaLoaded(true);
              klarnaObeservers.forEach((element) => {
                element.disconnect();
              });
            });
            klarnaObeservers.push(shadowRootKlarnaDivObserver);
            shadowRootKlarnaDivObserver.observe(klarnaPlacement.shadowRoot.querySelector("div"), {
              attributes: true,
            });
          }
          const shadowRootKlarnaObserver = new MutationObserver(function (mutations) {
            if (
              mutations?.some((item) => item?.addedNodes?.length > 0) &&
              klarnaPlacement.shadowRoot.querySelector("div")
            ) {
              const shadowRootKlarnaDivObserver = new MutationObserver(function () {
                setKlarnaLoaded(true);
                klarnaObeservers.forEach((element) => {
                  element.disconnect();
                });
              });
              klarnaObeservers.push(shadowRootKlarnaDivObserver);
              shadowRootKlarnaDivObserver.observe(klarnaPlacement.shadowRoot.querySelector("div"), {
                attributes: true,
              });
            } else if (mutations?.some((item) => item?.removedNodes?.length > 0)) {
              setKlarnaLoaded(false);
              klarnaObeservers.forEach((element) => {
                element.disconnect();
              });
            }
          });
          klarnaObeservers.push(shadowRootKlarnaObserver);
          shadowRootKlarnaObserver.observe(klarnaPlacement.shadowRoot, {
            childList: true,
          });
        }
      });
      activationKlarnaScript.observe(klarnaPlacement, {
        childList: true,
      });

      container.appendChild(klarnaPlacement);
      return () => {
        activationKlarnaScript.disconnect();
        container.removeChild(klarnaPlacement);
      };
    }
  }, [sellingPrice, clientId, enviroment, siteMetadata.priceLanguage]);

  return (
    <div
      className={classNames(klarnaLoaded ? "klarna-active" : "klarna-inactive")}
      ref={containerRef}
    ></div>
  );
};

export default React.memo(KlarnaPlacement);
